<template>
  <div>
    <router-view :key="moduleKey" v-if="moduleIsReady"/>
    <div v-else>Loading Prices Data...</div>
  </div>
</template>

<script>
import { FETCH_PRODUCT_TYPES, FETCH_CHARGEBY_OPTIONS } from './store';

export default {
  name: 'ProductPricesModule',

  created() {
    this.bootstrap();
  },

  computed: {

    moduleIsReady() {
      return !!this.getProductTypes;
    },

    moduleKey() {
      return 'ProductPriceModule';
    },
  },

  methods: {

    getProductTypes() {
      return this.$store.getters.productTypes;
    },
    async bootstrap() {
      // fetch data required for the whole module
      // console.log('From the bootstrap method');
      try {
        await this.$store.dispatch(FETCH_PRODUCT_TYPES);
        await this.$store.dispatch(FETCH_CHARGEBY_OPTIONS);
      } catch (err) {
        console.error('products price bootstrap err', err);
        if (err.message === 'Network Error') {
          this.$router.push({ name: 'NotFound' });
        } else {
          this.$router.push({ name: 'UnAuthorized' });
        }
      }
    },
  },
};
</script>

<style>

</style>
